<template lang="pug">
div
  v-tooltip(top, color="rgba(0, 0, 139, 0.95)")
    template(v-slot:activator="{ on, attrs }")
      .shift__card(
          v-bind="attrs",
          v-on="on",
          :style="{ backgroundColor: !shouldShowAvailableDuty && !shift.isUserDuty ? '#56a5e5' : (shift.bgColor || null) }",
          :class="{ [shift.dutyStatus.join(' ')]: true, 'shift__card--hasLabel': (seriesType !== 'PLANTÃO' && seriesType !== 'JORNADA') || (hideProgress === false && shouldShowCheckinCheckout && (shift.solicitado || shift.dutyStatus.some((s) => ['shift__card--passando', 'shift__card--encerrado', 'shift__card--iniciado', 'shift__card--pausado', 'shift__card--retomado'].includes(s)))), 'shift__card--hasUser': shift.isUserDuty, 'shift__card--hasScale': showScaleName && shift.scaleName, 'shift__card--hasValue': shouldShowsDutyValue, 'shift__card--no-pointer': !shouldShowAvailableDuty && !shift.isUserDuty }",
          @click.stop.prevent="shift.dutyStatus.includes('shift__card--aberto') && !shouldShowAvailableDuty ? null : open()"
        )
        //- LABELS
        template(v-if="seriesType !== 'PLANTÃO' && seriesType !== 'JORNADA'")
          span.dutyTypeName {{ seriesType }}
        template(v-else)
          span.shiftStatus(
            v-if="hideProgress === false && shouldShowCheckinCheckout &&  shift.solicitado === true"
          ) SOLICITADO
          span.shiftStatus(
            v-if="hideProgress === false && shouldShowCheckinCheckout && shift.dutyStatus.includes('shift__card--passando')"
          ) PASSANDO
          span.shiftStatus(
            v-if="hideProgress === false  && shouldShowCheckinCheckout && shift.dutyStatus.includes('shift__card--encerrado')"
          ) ENCERRADO
          span.shiftStatus(
            v-if="hideProgress === false && shouldShowCheckinCheckout && shift.dutyStatus.includes('shift__card--iniciado')"
          ) INICIADO
          span.shiftStatus(
            v-if="hideProgress === false && shouldShowCheckinCheckout && shift.dutyStatus.includes('shift__card--pausado')"
          ) PAUSADO
          span.shiftStatus(
            v-if="hideProgress === false && shouldShowCheckinCheckout && shift.dutyStatus.includes('shift__card--retomado')"
          ) RETOMADO

        //- BODY
        template
          //- NOME DO PLANTONISTA ou TIPO DE PLANTÃO
          span.dutyDetailsUserName(
            v-if="shift.isUserDuty",
            :title="shift.userName"
          )
            span.userNameValue(v-if="shouldShowUserName") {{ shift.userName }}
          span.dutyDetailsUserName(
            v-else-if="shift.isCanceled",
            title="Cancelado"
          )
            span.userNameValue Cancelado
          span.dutyDetailsUserName(
            v-else-if="shift.isExpired",
            title="Vencido"
          )
            span.userNameValue Vencido
          span.dutyDetailsUserName(
            v-else-if="shouldShowAvailableDuty && shift.dutyStatus.includes('shift__card--aberto')",
            title="Disponível"
          )
            span.userNameValue Disponível
          span.dutyDetailsUserName(
            v-else-if="shift.dutyStatus.includes('shift__card--aberto') && !shouldShowAvailableDuty && shouldShowUserName",
            title="Usuário"
          )
            span.userNameValue Usuário

          // - Telefone
          .shiftBodyItem(v-if="shouldShowPhone")
            span.shiftStartTimeTitle Telefone:
            span.shiftScaleName
              | &nbsp;{{ shift.phone }}

          //CRM
          .shiftBodyItem(
          v-if="shift.isUserDuty && shouldShowCrm && shift.crm && shift.crm.length > 0",
          :title="`CRM: ${shift.crm}`"
          )
            span.shiftStartTimeTitle CRM:
            span.shiftScaleName
              | &nbsp;{{ shift.crm }}


          //- DURAÇÃO
          .shiftBodyItem
            span.shiftStartTimeTitle Duração:
            span.shiftStartTime(:title="`Duração: ${shift.shiftDuration}`")
              | &nbsp;{{ shift.shiftDuration }}

          .shiftBodyItem
            span.shiftStartTimeTitle Fim:
            span.shiftStartTime(:title="`Fim: ${shift.endTime}`")
              | &nbsp;{{ shift.endTime }}

          .shiftBodyItem
            span.shiftStartTimeTitle Projeção:
            span.shiftStartTime(:title="`Projeção: ${dutySlotType}`")
              | &nbsp;{{ dutySlotType }}

          //- ESCALA
          .shiftBodyItem(
            v-if="showScaleName && shift.scaleName",
            :title="`Escala: ${shift.scaleName}`",
            style="margin-top: 4px"
          )
            span.shiftStartTimeTitle Escala:
            span.shiftScaleName
              | &nbsp;{{ shift.scaleName }}

          //- Nome do turno
          .shiftBodyItem(
            v-if="shift.shiftName",
            :title="`Turno: ${shift.shiftName}`",
            style="margin-top: 4px"
          )
            span.shiftStartTimeTitle Turno:
            span.shiftScaleName
              | &nbsp;{{ shift.shiftName }}



          //- Checkin/Checkout
          template(v-if="shouldShowCheckinCheckout")
            .shiftBodyItem(v-if="shift.checkin", style="margin-top: 4px")
              span.shiftStartTimeTitle Check-in:
              span.shiftScaleName
                | &nbsp;{{ shift.checkin }}
            .shiftBodyItem(v-if="shift.checkout", style="margin-top: 4px")
              span.shiftStartTimeTitle Check-out:
              span.shiftScaleName
                | &nbsp;{{ shift.checkout }}

        //- PASSING - Only show if professional photo is allowed
        template(v-if="shouldShowProfessionalPhoto")
          .shiftUserImageGroup(v-if="shift.isUserPassingThisShift")
            i.v-icon.notranslate.mdi.mdi-arrow-right-bold(aria-hidden="true")
            .shiftUserImage.shiftUserImage--receiver(
              :style="{ backgroundImage: `url(${shift.receivingPicture})` }"
            )
            .shiftUserImage.shiftUserImage--sender(
              :style="{ backgroundImage: `url(${shift.image})` }"
            )
          .shiftUserImage.shiftUserImage--one(
            v-else,
            :style="{ backgroundImage: `url(${shift.image})` }"
          )

        //- VALUE
        span.dutyUserValue(v-if="shouldShowsDutyValue && showValue") {{ shift.formattedValue }}

    //- TOOLTIP CONTENT
    .shiftInfoItem(v-if="shift.scaleName.length > 0")
      b.shiftInfoItemName.shiftInfoItemName--scaleName &nbsp;Escala:
      span.shiftInfoItemValue &nbsp;{{ shift.scaleName }}
      span.shiftInfoItemDivisorLine
    .shiftInfoItem(v-if="shouldShowUserName && shift.userName.length > 0")
      b.shiftInfoItemName &nbsp;Nome:
      span.shiftInfoItemValue &nbsp;{{ shift.userName }}
    .shiftInfoItem(
      v-if="hideProgress === false && shift.statusName.length > 0"
    )
      b.shiftInfoItemName &nbsp;Status:
      span.shiftInfoItemValue &nbsp;{{ shift.statusName }}
    .shiftInfoItem(v-if="shouldShowDutyDetails && seriesType")
      b.shiftInfoItemName &nbsp;Tipo:
      span.shiftInfoItemValue &nbsp;{{ seriesType }}
    template(v-if="shouldShowCheckinCheckout")
      .shiftInfoItem(v-if="shift.checkin")
        b.shiftInfoItemName &nbsp;Check-in:
        span.shiftInfoItemValue &nbsp;{{ shift.checkin }}
      .shiftInfoItem(v-if="shift.checkout")
        b.shiftInfoItemName &nbsp;Check-out:
        span.shiftInfoItemValue &nbsp;{{ shift.checkout }}

    .shiftInfoItem(v-if="dutySlotType")
      b.shiftInfoItemName &nbsp;Projeção:
      span.shiftInfoItemValue &nbsp;{{ dutySlotType }}
</template>

<script>
import { getSeriesTypeLabel } from "@/constants/series";
import { SERIES_DAY_OFF, SERIES_VACATION } from "../constants/series";
import { GRUPO_VER_VALORES } from "@/constants";
import moment from "moment";
import "moment/locale/pt-br";
import { calculateEndTime } from '@/mixins/utils';
import { mapState } from 'vuex';

export default {
  name: "SosShiftCard",

  props: {
    hideProgress: { type: Boolean, default: false },
    showValue: { type: Boolean, default: true },
    shift: { type: Object, required: true },
    showScaleName: { type: Boolean, default: false },
    shareDetails: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    ...mapState({
      currentGroupCapabilities: state => state.app.currentGroupCapabilities,
    }),

    dutySlotType() {
      return (this.shift.slotType || "") === "FOLLOW_UP" ? "Retorno" : (
        (this.shift.slotType || "") === "FIRST_APPOINTMENT" ? "1ª consulta" : "Ambos"
      )
    },

    isVacationType() {
      return this.shift && this.shift.type === SERIES_VACATION;
    },
    isDayOffType() {
      return this.shift && this.shift.type === SERIES_DAY_OFF;
    },
    seriesType() {
      return getSeriesTypeLabel(this.shift?.type || "").toUpperCase();
    },
    shouldShowDutyDetails() {
      return !(this.shareDetails && !this.shareDetails.show_shift_details);
    },
    shouldShowUserName() {
      return !(this.shareDetails && !this.shareDetails.show_professional_name)
    },
    shouldShowProfessionalPhoto() {
      if (this.shareDetails && !this.shareDetails.show_professional_photo)
        return false;
      return this.shift.image;
    },
    shouldShowAvailableDuty() {
      return !(this.shareDetails && !this.shareDetails.show_available_shifts);
    },

    permissaoVerValores() {
      return !!this.currentGroupCapabilities && !!this.currentGroupCapabilities[GRUPO_VER_VALORES];
    },

    shouldShowsDutyValue() {
      if (this.shareDetails && !this.shareDetails.show_shift_value)
        return false;
      if (!this.permissaoVerValores)
        return false;
      return this.shift.valor > 0;
    },
    //show_checkin_check
    shouldShowCheckinCheckout() {
      if (this.shareDetails && !this.shareDetails.show_checkin_checkout)
        return false;
      return !!(this.shift.checkin || this.shift.checkout || this.shift.shiftStatus === 'iniciado' || this.shift.shiftStatus === 'encerrado' || this.shift.shiftStatus === 'pausado' || this.shift.shiftStatus === 'retomado');
    },
    //show crm
    shouldShowCrm() {
      if (this.shareDetails && !this.shareDetails.show_professional_crm)
        return false;
      return this.shift.crm && this.shift.crm.length > 0;
    },
    //show phone
    shouldShowPhone() {
      if (this.shareDetails && !this.shareDetails.show_professional_phone)
        return false;
      return this.shift.phone && this.shift.phone.length > 0;
    },

    // removido em 26/08/2025 -> a logica foi movida para o filteredDutties
    // isShiftVisible() {

    //   if (
    //     !this.shareDetails ||
    //     !this.shareDetails.valid_from ||
    //     !this.shareDetails.valid_to
    //   ) {
    //     return true;
    //   }

    //   moment.locale("pt-br");

    //   const shiftStart = moment(this.shift.dataInicio);

    //   // shift.shiftDuration está no formato "HH:mm"
    //   let shiftEnd = shiftStart.clone();
    //   if (this.shift.shiftDuration) {
    //     const [hours, minutes] = this.shift.duration.split(":").map(Number);
    //     shiftEnd = shiftEnd.add(hours, "hours").add(minutes, "minutes");
    //   }

    //   const validFrom = moment(this.shareDetails.valid_from);
    //   const validTo = moment(this.shareDetails.valid_to);

    //   // Verifica se o plantão está completamente dentro do intervalo
    //   // ou se há qualquer sobreposição entre os intervalos
    //   const visible =
    //     (shiftStart.isAfter(validFrom) && shiftStart.isBefore(validTo)) ||
    //     (shiftEnd.isAfter(validFrom) && shiftEnd.isBefore(validTo)) ||
    //     (shiftStart.isSameOrBefore(validFrom) &&
    //       shiftEnd.isSameOrAfter(validTo));
    //   return visible;
    // },
  },

  methods: {
    open() {
      this.$emit("open", this.shift);
    },
  },
};
</script>

<style lang="scss" scoped>
.shiftInfoItem {
  font-size: 0;
  line-height: 1.5;
}

.shiftInfoItemName {
  color: lightgreen;
  font-size: 14px;
  font-weight: 600;
}

.shiftInfoItemValue {
  font-size: 14px;
  font-weight: 500;
}

.shiftInfoItemDivisorLine {
  display: inline-block;
  width: 100%;
  height: 1px;
  margin: 5px 0;
  background-color: rgba(255, 255, 255, 0.5);
}

.shiftUserImageGroup {
  position: absolute;
  top: 0;
  right: 7px;
  bottom: 0;

  width: 45px;
  height: 65px;
  margin-top: auto;
  margin-bottom: auto;

  /* position: absolute;
    top: 0;
    right: 7px;
    bottom: 0;

    width: 50px;
    height: 55px;
    margin-top: auto;
    margin-bottom: auto; */

  >i {
    z-index: 2;
    position: absolute;
    top: 0;
    right: 5px;

    color: yellow;
    font-size: 20px;

    /* z-index: 2;
      position: absolute;
      top: 5px;
      right: 35px;

      transform: rotate(-35deg);

      font-size: 16px; */
  }
}

.shiftUserImage {
  position: absolute;

  margin-top: auto;
  margin-bottom: auto;

  display: inline-block;
  vertical-align: middle;
  width: 100%;
  height: 100%;
  max-width: 45px;
  max-height: 65px; // 45px;
  border-radius: 6px; // 50%;
  background-size: cover;
  background-position-x: center;
  background-position-y: center;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  background-color: #d3d3d3;

  &--one {
    top: 0;
    right: 5px; // 7px;
    bottom: 0;
  }

  &--receiver {
    top: 0;
    right: 0;
    bottom: auto;

    max-width: 22.5px;
    max-height: 65px;

    filter: grayscale(1);

    /* top: 0;
      right: 0;
      bottom: auto;

      max-width: 30px;
      max-height: 30px; */
  }

  &--sender {
    top: 0;
    right: 22.5px;
    bottom: auto;

    max-width: 22.5px;
    max-height: 65px;
    box-shadow: 1px 1px 0px rgba(255, 255, 0, 1);

    /* top: 20px;
      right: 15px;
      bottom: auto;

      max-width: 35px;
      max-height: 35px; */
  }
}

.dutyUserValue {
  position: absolute;
  // bottom: 9px;
  // right: 7px;
  bottom: 4px;
  right: 5px;

  display: inline-block;
  vertical-align: middle;
  padding: 2px 3px;
  border-radius: 3px;
  background-image: linear-gradient(180deg, #ffffc5, #ffff00);

  color: #000;
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  text-align: center;

  &--solo {
    bottom: 0px;
    right: 0px;
  }
}

.shift__card--no-pointer {
  cursor: default !important;
}

.shiftStatus {
  position: absolute;
  top: 0;
  left: 0;

  width: 50%; // 100%;
  border-bottom-right-radius: 10px;
  // border-top: 1px solid rgba(0, 0, 0, 0.25);
  background-color: rgba(0, 0, 0, 0.35);

  color: #eeeeee;
  font-size: 9px;
  font-weight: 800;
  line-height: 11px;
  text-align: center;
  letter-spacing: 0.5px;
}

/* .dutyDetails {
    z-index: 1;
    position: relative;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    padding: 9px 60px 9px 12px;
    text-align: left;
  } */

.dutyDetailsUserName {
  line-height: 0;
}

.userNameValue {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;

  // padding-right: 5px;
  // padding-left: 2px;
  // padding-bottom: 2px;

  // border-radius: 7px;
  // background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.03), transparent);

  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.7), 1px -1px 4px rgba(0, 0, 0, 0.4);
  text-overflow: ellipsis;
}

.shiftStartTimeTitle {
  color: cornsilk;
}

.shiftStartTime {}

.dutyDetailsDurationText {}

.shiftScaleNameTitle {
  color: #d9ff9e;
}

.shiftScaleName {}

.shiftBodyItem {
  width: 100%; // Ellipsis
  overflow: hidden; // Ellipsis
  // padding-left: 2px;

  font-weight: 600;
  text-overflow: ellipsis; // Ellipsis
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.6), -1px -1px 3px rgba(0, 0, 0, 0.25);
}

.shift__card {
  cursor: pointer;

  position: relative;

  min-height: 75px;
  padding: 7px 55px 9px 10px;
  // padding: 9px 55px 9px 10px;
  // padding: 9px 60px 9px 10px;
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  border-left: 1px solid rgba(255, 255, 255, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  box-shadow: inset 3px -3px 20px -3px rgba(0, 0, 0, 0.25);
  background-image: linear-gradient(360deg, rgba(0, 0, 0, 0.1), transparent);

  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  white-space: nowrap;

  overflow: hidden;

  // FLOATING LABEL
  &--hasLabel {
    padding: 21px 55px 4px 10px;
    // padding: 21px 60px 4px 10px;

    // padding: 14px 60px 4px 10px;
    // 21px 60px 9px 10px

    // Jesus
    /* .shiftUserImage--one {
        top: 12px;
      } */

    &.shift__card--hasScale {
      padding: 17px 55px 4px 10px;
    }
  }

  &--hasValue {
    .shiftUserImage--one {
      top: 5px; // 7px;
      margin-top: 0;
    }
  }

  /* &.shift__card--hasScale.shift__card--hasValue {
      .shiftUserImage--one {
        top: 13px;
      }

      .dutyUserValue {
        bottom: 13px;
      }
    } */

  /* &.shift__card--passando.shift__card--hasScale.shift__card--hasValue {
      .shiftUserImageGroup {
        top: 7px;
        margin-top: 0;
      }

      .dutyUserValue {
        bottom: 7px;
      }
    } */

  /* &.shift__card--passando.shift__card--hasValue {
      .shiftUserImageGroup {
        top: 2px;
        margin-top: 0;
      }

      .dutyUserValue {
        bottom: 2px;
      }
    } */

  &.shift__card--aberto {
    background-color: #00cb72;
  }

  // &.shift__card--requested {
  // background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.3), transparent);
  // }

  &.shift__card--fechado {
    background-color: #2196f3;

    &.shift__card--passando {
      background-color: #0f88fe;
    }
  }

  &.shift__card--vencido {
    // opacity: 0.6;
    opacity: 0.75;

    /* .userNameValue, .shiftStartTime, .dutyDetailsDurationText {
        // color: rgb(228, 228, 228);
        color: #f6f6f6;
      } */

    .shiftUserImage,
    .dutyUserValue {
      opacity: 0.9; // 0.8;
      filter: grayscale(1);
    }
  }

  &.shift__card--cancelado {
    background-color: #ff5a5a;
  }

  &.shift__card--pausado .shiftStatus {
    color: yellow;
    // border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    background-color: indianred;
  }

  &.shift__card--passando .shiftStatus {
    color: yellow;
    // background-color: indianred;
  }

  &.shift__card--dayOff {
    background-color: #d4b300 !important;
  }

  &.shift__card--vacation {
    background-color: #d4b300 !important;
  }
}

//
//
//

.shift__card--aberto .shiftUserImage.shiftUserImage--one {
  background-size: auto;
  background-color: #e4e6e7;
}

.shift__card--aberto.shift__card--requested .shiftUserImage.shiftUserImage--one {
  background-position-y: center;
  background-size: auto;
  background-color: #e4e6e7;
}

.dutyTypeName {
  position: absolute;
  top: 0;
  left: 0;

  width: 50%;
  border-bottom-right-radius: 10px;
  background-color: palegreen;

  color: darkgreen;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  text-align: center;
  letter-spacing: 0.5px;
}

//
//
//

@media (max-width: 600px) {
  .userNameValue {
    max-width: 100%;
  }
}
</style>
